import {
  ListenerEvent,
  IncomingMessage,
  MessageHandler
} from '@carvana/merch-native';
import { useContext, useMemo } from 'react';
import ErrorContext from '~/context/common/ErrorContext';
import { logError } from '~/utilities/errorHandlers';

type ErrorMessage = IncomingMessage<
  ListenerEvent,
  {
    errorMessage: string;
  }
>;

function isErrorMessage(
  message: IncomingMessage<ListenerEvent, any>
): message is ErrorMessage {
  return (
    message.event === ListenerEvent.Error &&
    message.payload.errorMessage != null
  );
}

export default function useErrorHandler(): MessageHandler<ListenerEvent> {
  const { setNativeError } = useContext(ErrorContext);

  return useMemo(
    () =>
      new MessageHandler(isErrorMessage, (message: ErrorMessage) => {
        const { errorMessage, ...context } = message.payload;
        const err = new Error(errorMessage);

        setNativeError(err);
        logError(err, { location: 'Native', ...context });
      }),
    [setNativeError]
  );
}
